export default {
  cloneRow (obj) {
    var data = {}
    for (var v in obj) {
      data[v] = obj[v]
    }
    return data
  },
  cloneRows (obj) {
    var data = []
    for (var v in obj) {
      data[v] = obj[v]
    }
    return data
  }
}



// WEBPACK FOOTER //
// ./src/common/methodBus.js